// extracted by mini-css-extract-plugin
export default {"tag_container":"Tagtabs_tag_container__GzWIS","tag_label":"Tagtabs_tag_label__DeL3G","delete_tag":"Tagtabs_delete_tag__r8dT4"};